document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.testimonials-carousel').forEach(initCarousel);
});

function initCarousel(root) {
  const track = root.querySelector('.testimonials-carousel__track');
  const prevBtn = root.querySelector('[data-prev]');
  const nextBtn = root.querySelector('[data-next]');
  const items = track ? Array.from(track.querySelectorAll('.testimonials-carousel__item')) : [];

  if (!track || items.length <= 1) return;

  function getItemStep() {
    const style = window.getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || 0);
    return items[0].getBoundingClientRect().width + gap;
  }

  function isAtEnd() {
    return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }

  function isAtStart() {
    return track.scrollLeft <= 2;
  }

  function scrollByOneItem(direction) {
    const step = getItemStep();

    if (direction > 0 && isAtEnd()) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    if (direction < 0 && isAtStart()) {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      return;
    }

    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', () => scrollByOneItem(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => scrollByOneItem(1));
}